export default "__VITE_ASSET__DD3YF1n1__"